import type { AttributeDefinition } from './attributes.types';

const WS = 'ws-fixture-1';
const ORG = 'org-fixture-1';

/** Realistic mixed-scope definitions for mock layer. */
export const MOCK_ATTRIBUTE_DEFINITIONS: AttributeDefinition[] = [
  {
    id: 'attr-sys-risk-level',
    organizationId: null,
    scope: 'SYSTEM',
    workspaceId: null,
    key: 'risk_level',
    label: 'Risk Level',
    dataType: 'single_select',
    locked: false,
    required: false,
    isActive: true,
    defaultValue: null,
    options: { values: ['Low', 'Medium', 'High', 'Critical'] },
  },
  {
    id: 'attr-sys-customer-impact',
    organizationId: null,
    scope: 'SYSTEM',
    workspaceId: null,
    key: 'customer_impact',
    label: 'Customer Impact',
    dataType: 'rating',
    locked: false,
    required: false,
    isActive: true,
    defaultValue: null,
    options: null,
  },
  {
    id: 'attr-org-sla-tier',
    organizationId: ORG,
    scope: 'ORG',
    workspaceId: null,
    key: 'sla_tier',
    label: 'SLA Tier',
    dataType: 'single_select',
    locked: true,
    required: true,
    isActive: true,
    defaultValue: 'Standard',
    options: { values: ['Standard', 'Premium', 'Enterprise'] },
  },
  {
    id: 'attr-org-billable',
    organizationId: ORG,
    scope: 'ORG',
    workspaceId: null,
    key: 'billable',
    label: 'Billable',
    dataType: 'boolean',
    locked: false,
    required: false,
    isActive: true,
    defaultValue: true,
    options: null,
  },
  {
    id: 'attr-ws-story-points-custom',
    organizationId: ORG,
    scope: 'WORKSPACE',
    workspaceId: WS,
    key: 'tshirt_size',
    label: 'T-Shirt Size',
    dataType: 'single_select',
    locked: false,
    required: false,
    isActive: true,
    defaultValue: null,
    options: { values: ['XS', 'S', 'M', 'L', 'XL'] },
  },
  {
    id: 'attr-ws-target-date',
    organizationId: ORG,
    scope: 'WORKSPACE',
    workspaceId: WS,
    key: 'target_date',
    label: 'Target Date',
    dataType: 'date',
    locked: false,
    required: false,
    isActive: true,
    defaultValue: null,
    options: null,
  },
  {
    id: 'attr-ws-effort-hours',
    organizationId: ORG,
    scope: 'WORKSPACE',
    workspaceId: WS,
    key: 'effort_hours',
    label: 'Effort Hours',
    dataType: 'number',
    locked: false,
    required: false,
    isActive: true,
    defaultValue: null,
    options: null,
  },
  {
    id: 'attr-ws-notes',
    organizationId: ORG,
    scope: 'WORKSPACE',
    workspaceId: WS,
    key: 'notes',
    label: 'Notes',
    dataType: 'text',
    locked: false,
    required: false,
    isActive: true,
    defaultValue: null,
    options: null,
  },
];

/** taskId → definitionId → value */
export const MOCK_ATTRIBUTE_VALUES: Record<string, Record<string, unknown>> = {
  'task-1': {
    'attr-sys-risk-level': 'Medium',
    'attr-org-billable': true,
    'attr-ws-effort-hours': 8,
  },
  'task-2': {
    'attr-sys-customer-impact': 4,
    'attr-org-sla-tier': 'Premium',
  },
};
